import Request from "./request";

export const getLocation = async (id: string) => {
  return Request.call({
    url: "/location/getLocation",
    method: "POST",
    data: { locationId: id },
  });
};
